var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "q-pb-xl layout-padding" }, [
    _c(
      "div",
      { staticClass: "row" },
      [
        _c(
          "h5",
          {
            staticClass: "q-pa-md col-12",
            staticStyle: { "padding-bottom": "0" }
          },
          [
            _c("q-icon", {
              attrs: { color: "primary", name: "fa fa-building" }
            }),
            _vm._v(" Affiliate Information\n    ")
          ],
          1
        ),
        _c(
          "q-field",
          {
            staticClass: "q-pa-md col-4",
            attrs: {
              "error-label": "Affiliate Name is required",
              error: _vm.validation.affiliateForm.AFFILIATE_NAME.$error
            }
          },
          [
            _c("q-input", {
              attrs: {
                "float-label": "Affiliate Name",
                after: [
                  {
                    icon: "flag",
                    color: "red",
                    class: "exclamation-circle-icon",
                    condition:
                      _vm.validation.affiliateForm.AFFILIATE_NAME.$invalid
                  },
                  {
                    icon: "fa fa-check",
                    condition: !_vm.validation.affiliateForm.AFFILIATE_NAME
                      .$invalid
                  }
                ],
                disable: !_vm.canEdit
              },
              on: { blur: _vm.validation.affiliateForm.AFFILIATE_NAME.$touch },
              model: {
                value: _vm.affiliateForm.AFFILIATE_NAME,
                callback: function($$v) {
                  _vm.$set(_vm.affiliateForm, "AFFILIATE_NAME", $$v)
                },
                expression: "affiliateForm.AFFILIATE_NAME"
              }
            })
          ],
          1
        ),
        _c(
          "q-field",
          {
            staticClass: "q-pa-md col-4",
            attrs: {
              "error-label": "Affiliate Code is required",
              error: _vm.validation.affiliateForm.AFFILIATE_CODE.$error,
              helper: _vm.affiliateCodeHelper
            }
          },
          [
            _c("q-input", {
              attrs: {
                "float-label": "Affiliate Code",
                after: [
                  {
                    icon: "flag",
                    color: "red",
                    class: "exclamation-circle-icon",
                    condition:
                      _vm.validation.affiliateForm.AFFILIATE_CODE.$invalid
                  },
                  {
                    icon: "fa fa-check",
                    condition: !_vm.validation.affiliateForm.AFFILIATE_CODE
                      .$invalid
                  }
                ],
                disable: !_vm.canEdit || !_vm.$p(["ADMIN", "MANAGER"], "or")
              },
              on: { blur: _vm.validation.affiliateForm.AFFILIATE_CODE.$touch },
              model: {
                value: _vm.affiliateForm.AFFILIATE_CODE,
                callback: function($$v) {
                  _vm.$set(_vm.affiliateForm, "AFFILIATE_CODE", $$v)
                },
                expression: "affiliateForm.AFFILIATE_CODE"
              }
            })
          ],
          1
        ),
        _c(
          "q-field",
          {
            staticClass: "q-pa-md col-4",
            attrs: {
              "error-label": "Either FEIN or SSN is required",
              error:
                _vm.validation.affiliateForm
                  .FEDERAL_EMPLOYER_IDENTIFICATION_NUMBER.$error
            }
          },
          [
            _c("q-input", {
              directives: [
                {
                  name: "mask",
                  rawName: "v-mask",
                  value: "99-9999999",
                  expression: "'99-9999999'"
                }
              ],
              attrs: {
                "float-label": "Federal Employer Identification #",
                value: _vm.affiliateForm.FEDERAL_EMPLOYER_IDENTIFICATION_NUMBER,
                after: [
                  {
                    icon: "flag",
                    color: "red",
                    class: "exclamation-circle-icon",
                    condition:
                      _vm.validation.affiliateForm
                        .FEDERAL_EMPLOYER_IDENTIFICATION_NUMBER.$invalid
                  },
                  {
                    icon: "fa fa-check",
                    condition: !_vm.validation.affiliateForm
                      .FEDERAL_EMPLOYER_IDENTIFICATION_NUMBER.$invalid
                  }
                ],
                disable: !_vm.canEdit
              },
              on: {
                blur:
                  _vm.validation.affiliateForm
                    .FEDERAL_EMPLOYER_IDENTIFICATION_NUMBER.$touch,
                keyup: function($event) {
                  $event.stopPropagation()
                  _vm.updateAffiliateForm({
                    field: "FEDERAL_EMPLOYER_IDENTIFICATION_NUMBER",
                    value: $event.target.value
                  })
                }
              }
            })
          ],
          1
        ),
        _c("div", { staticClass: "col-12 q-px-md q-pb-md" }, [
          _c("b", [_vm._v("Available Credits")]),
          _c("br"),
          _c("b", [_vm._v("$" + _vm._s(_vm.affiliateForm.AVAILABLE_CREDITS))])
        ])
      ],
      1
    ),
    _c("div", { staticClass: "row" }),
    _c(
      "div",
      { staticClass: "row" },
      [
        _c(
          "h6",
          {
            staticClass: "q-pa-md col-12",
            staticStyle: { "padding-bottom": "0" }
          },
          [
            _c("q-icon", {
              attrs: { color: "primary", name: "fa fa-user-plus" }
            }),
            _vm._v(" Recruiter Information\n    ")
          ],
          1
        ),
        _c(
          "q-field",
          {
            staticClass: "q-pa-md col-4",
            attrs: {
              "error-label": "Student Processing Fee is required",
              error: _vm.validation.affiliateForm.STUDENT_PROCESSING_FEE.$error
            }
          },
          [
            _c("q-input", {
              attrs: {
                "float-label": "Student Processing Fee",
                before: [{ icon: "attach_money" }],
                after: [
                  {
                    icon: "flag",
                    color: "red",
                    class: "exclamation-circle-icon",
                    condition:
                      _vm.validation.affiliateForm.STUDENT_PROCESSING_FEE
                        .$invalid
                  },
                  {
                    icon: "fa fa-check",
                    condition: !_vm.validation.affiliateForm
                      .STUDENT_PROCESSING_FEE.$invalid
                  }
                ],
                disable: !_vm.canEdit,
                required: ""
              },
              on: {
                blur: _vm.validation.affiliateForm.STUDENT_PROCESSING_FEE.$touch
              },
              model: {
                value: _vm.affiliateForm.STUDENT_PROCESSING_FEE,
                callback: function($$v) {
                  _vm.$set(_vm.affiliateForm, "STUDENT_PROCESSING_FEE", $$v)
                },
                expression: "affiliateForm.STUDENT_PROCESSING_FEE"
              }
            })
          ],
          1
        ),
        _c(
          "q-field",
          { staticClass: "q-pa-md col-4" },
          [
            _c("q-select", {
              attrs: {
                "float-label": "Recruiter",
                options: _vm.recruiterOptions,
                filter: "",
                "autofocus-filter": "",
                clearable: "",
                disable: !_vm.canEdit || _vm.$p(["RECRUITER"])
              },
              on: {
                input: function(val) {
                  return _vm.updateAffiliateForm({
                    field: "RECRUITER_ID",
                    value: val
                  })
                }
              },
              model: {
                value: _vm.affiliateForm.RECRUITER_ID,
                callback: function($$v) {
                  _vm.$set(_vm.affiliateForm, "RECRUITER_ID", $$v)
                },
                expression: "affiliateForm.RECRUITER_ID"
              }
            })
          ],
          1
        ),
        _c(
          "q-field",
          {
            staticClass: "q-pa-md col-4",
            attrs: {
              "error-label":
                "Recruiter fee must be less than student processing fee",
              error: _vm.validation.affiliateForm.RECRUITER_FEE.$error
            }
          },
          [
            _c("q-input", {
              attrs: {
                "float-label": "Recruiter Fee",
                value: _vm.affiliateForm.RECRUITER_FEE,
                after: [
                  {
                    icon: "flag",
                    color: "red",
                    class: "exclamation-circle-icon",
                    condition:
                      _vm.validation.affiliateForm.RECRUITER_FEE.$invalid
                  },
                  {
                    icon: "fa fa-check",
                    condition: !_vm.validation.affiliateForm.RECRUITER_FEE
                      .$invalid
                  }
                ],
                disable: !_vm.canEdit,
                required: ""
              },
              on: {
                keyup: function($event) {
                  $event.stopPropagation()
                  _vm.updateAffiliateForm({
                    field: "RECRUITER_FEE",
                    value: $event.target.value
                  })
                },
                blur: _vm.validation.affiliateForm.RECRUITER_FEE.$touch
              }
            })
          ],
          1
        )
      ],
      1
    ),
    _c("div", { staticClass: "row" }),
    _c(
      "div",
      { staticClass: "row" },
      [
        _c(
          "h6",
          {
            staticClass: "q-pa-md col-12",
            staticStyle: { "padding-bottom": "0" }
          },
          [
            _c("q-icon", { attrs: { color: "primary", name: "fa fa-info" } }),
            _vm._v(" Affiliate Contact\n    ")
          ],
          1
        ),
        _c(
          "q-field",
          { staticClass: "q-pa-md col-4" },
          [
            _c("q-input", {
              attrs: {
                "float-label": "Contact Name",
                value: _vm.affiliateForm.CONTACT_NAME,
                disable: !_vm.canEdit,
                required: ""
              },
              on: {
                keyup: function($event) {
                  $event.stopPropagation()
                  _vm.updateAffiliateForm({
                    field: "CONTACT_NAME",
                    value: $event.target.value
                  })
                }
              }
            })
          ],
          1
        ),
        _c(
          "q-field",
          { staticClass: "q-pa-md col-4" },
          [
            _c("q-input", {
              directives: [
                {
                  name: "mask",
                  rawName: "v-mask",
                  value: "999-999-9999",
                  expression: "'999-999-9999'"
                }
              ],
              attrs: {
                "float-label": "Contact Phone",
                type: "tel",
                value: _vm.affiliateForm.CONTACT_PHONE,
                disable: !_vm.canEdit,
                required: ""
              },
              on: {
                keyup: function($event) {
                  $event.stopPropagation()
                  _vm.updateAffiliateForm({
                    field: "CONTACT_PHONE",
                    value: $event.target.value
                  })
                }
              }
            })
          ],
          1
        ),
        _c(
          "q-field",
          { staticClass: "q-pa-md col-4" },
          [
            _c("q-input", {
              attrs: {
                "float-label": "Contact Email",
                value: _vm.affiliateForm.CONTACT_EMAIL,
                disable: !_vm.canEdit
              },
              on: {
                keyup: function($event) {
                  $event.stopPropagation()
                  _vm.updateAffiliateForm({
                    field: "CONTACT_EMAIL",
                    value: $event.target.value
                  })
                }
              }
            })
          ],
          1
        )
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "row" },
      [
        _c(
          "h6",
          {
            staticClass: "q-pa-md col-12",
            staticStyle: { "padding-bottom": "0" }
          },
          [
            _c("q-icon", { attrs: { color: "primary", name: "fa fa-book" } }),
            _vm._v(" Courses\n    ")
          ],
          1
        ),
        _c(
          "q-field",
          {
            staticClass: "q-pa-md col-12",
            attrs: {
              error: _vm.validation.affiliateForm.COURSES.$error,
              "error-label": "Must assign at least one course to Affiliate!"
            }
          },
          [
            _c("q-select", {
              attrs: {
                chips: "",
                multiple: "",
                "float-label": "Courses",
                value: _vm.affiliateCourseIds,
                options: _vm.courseOptions,
                after: [
                  {
                    icon: "flag",
                    color: "red",
                    class: "exclamation-circle-icon",
                    condition: _vm.validation.affiliateForm.COURSES.$invalid
                  },
                  {
                    icon: "fa fa-check",
                    condition: !_vm.validation.affiliateForm.COURSES.$invalid
                  }
                ],
                filter: "",
                "autofocus-filter": "",
                disable: !_vm.canEdit || _vm.$p(["RECRUITER", "MANAGER"])
              },
              on: {
                input: function(affiliateCourseIds) {
                  return this$1.updateAffiliateForm({
                    field: "COURSES",
                    value: affiliateCourseIds.map(function(courseId) {
                      return { COURSE_ID: courseId }
                    })
                  })
                }
              }
            })
          ],
          1
        )
      ],
      1
    ),
    _vm.$p(["ADMIN"])
      ? _c("div", { staticClass: "row" }, [
          _c(
            "h6",
            {
              staticClass: "q-pa-md col-12",
              staticStyle: { "padding-bottom": "0" }
            },
            [
              _c("q-icon", {
                attrs: { color: "primary", name: "fa fa-print" }
              }),
              _vm._v(" Print Permissions\n    ")
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "q-pa-md col-12" },
            [
              _vm.$p(["ADMIN"])
                ? _c("q-checkbox", {
                    attrs: {
                      label: "Can Print Certificate Copies",
                      value: _vm.affiliateForm.PRINT_PERMISSION,
                      "true-value": 1,
                      "false-value": 0,
                      "indeterminate-icon": "check_box_outline_blank"
                    },
                    on: {
                      input: function(val) {
                        return this$1.updateAffiliateForm({
                          field: "PRINT_PERMISSION",
                          value: val
                        })
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ])
      : _vm._e(),
    _vm.$p(["ADMIN"])
      ? _c("div", { staticClass: "row" }, [
          _c(
            "h6",
            {
              staticClass: "q-pa-md col-12",
              staticStyle: { "padding-bottom": "0" }
            },
            [
              _c("q-icon", { attrs: { color: "primary", name: "fa fa-file" } }),
              _vm._v(" Data Entry\n    ")
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "q-pa-md col-12" },
            [
              _vm.$p(["ADMIN"])
                ? _c("q-checkbox", {
                    attrs: {
                      label: "School Entered",
                      value: _vm.affiliateForm.SCHOOL_ENTERED,
                      "true-value": 1,
                      "false-value": 0,
                      "indeterminate-icon": "check_box_outline_blank"
                    },
                    on: {
                      input: function(val) {
                        return this$1.updateAffiliateForm({
                          field: "SCHOOL_ENTERED",
                          value: val
                        })
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }